var registeredInstances = {};

export class ListMultiselect {

  options = {
    table: null,
    selectedValues: [],
    onChange: function(evt, data) {
    },
    onClear: function(evt) {
    },
    confirmCheck: function(callback) {
      callback(true)
    },
    confirmUncheck: function(callback) {
      callback(true)
    }
  }

  constructor(table, opts) {
    if(!(table instanceof HTMLElement)){
      table = document.querySelector(table);
    }

    this.options.table = table;
    Object.assign(this.options, opts);

    for (const value of this.options.selectedValues) {
      let el = this.options.table.querySelector(`.list-multiselect-single[value="${value}"]`);
      if(el != null){
        el.checked = true;
      }
    }

    this.registerListeners();
    this.refreshActionWrapper();
  }

  refreshActionWrapper() {
    if(this.options.selectedValues.length > 0) {
      $(".list-multiselect-actions-wrapper").addClass("active");
    } else {
      $(".list-multiselect-actions-wrapper").removeClass("active");
    }
  }

  check(values) {
    if(!(values instanceof Array)){
      values = [values];
    }

    let changes = [];

    for (const value of values) {
      if(this.options.selectedValues.indexOf(value) === -1) {

        let checkbox = this.options.table.querySelector(`.list-multiselect-single[value="${value}"]`);
        if(checkbox != null){
          checkbox.checked = true;
        }

        changes.push({
          checked: true,
          value: value
        });

        this.options.selectedValues.push(value);
      }
    }

    this.refreshActionWrapper();

    return changes;
  }

  uncheck(values) {
    if(!(values instanceof Array)){
      values = [values];
    }

    let changes = [];

    for (const value of values) {
      if(this.options.selectedValues.indexOf(value) !== -1) {

        let checkbox = this.options.table.querySelector(`.list-multiselect-single[value="${value}"]`);
        if(checkbox != null){
          checkbox.checked = false;
        }

        changes.push({
          checked: false,
          value: value
        });

        this.options.selectedValues = this.options.selectedValues.filter(v => v != value);
      }
    }

    this.refreshActionWrapper();

    return changes;
  }

  clear() {
    return this.uncheck(this.options.selectedValues);
  }

  registerListeners() {
    let that = this;

    $(this.options.table).on("change", ".list-multiselect-all", function(evt) {
      let checked = $(this).prop("checked");
      if(checked) {
        that.options.confirmCheck((values) => {
          let changes = that.check(values);
          that.options.onChange(evt, {
            changes: changes
          })
        })
      } else {
        that.options.confirmUncheck((values) => {
          let changes = that.uncheck(values);
          that.options.onChange(evt, {
            changes: changes
          })
        })
      }
    });

    $(this.options.table).on("change", ".list-multiselect-single", function(evt) {
      let checked = $(this).prop("checked");

      if(checked) {
        that.options.onChange(evt, {
          changes: that.check(this.value)
        })
      } else {
        that.options.onChange(evt, {
          changes: that.uncheck(this.value)
        })
      }

    });

    $(document).on("click", ".list-multiselect-clear", function(evt) {
      let changes = that.clear();

      that.options.onChange(evt, {
        changes: changes
      })

      that.options.onClear(evt);
    });

  }


}

$.fn.listMultiselect = function(opts) {
  var $table = $(this);
  registeredInstances[$table] = new ListMultiselect($table[0], opts)
  return registeredInstances[$table];
}